import React, { useState, useEffect, useCallback } from 'react';

/**
 * AlertToast — Real-time notification component.
 * Slides in from top-right, auto-dismisses after 8s.
 * Themed with the purple/ember palette.
 */
export default function AlertToast({ alerts = [], onDismiss }) {
    return (
        <div className="toast-container">
            {alerts.map((alert, idx) => (
                <ToastItem
                    key={alert.id || idx}
                    alert={alert}
                    onDismiss={() => onDismiss(alert.id)}
                />
            ))}
        </div>
    );
}

function ToastItem({ alert, onDismiss }) {
    const [visible, setVisible] = useState(false);
    const [exiting, setExiting] = useState(false);

    useEffect(() => {
        // Slide in
        requestAnimationFrame(() => setVisible(true));

        // Auto-dismiss after 8s
        const timer = setTimeout(() => {
            setExiting(true);
            setTimeout(onDismiss, 400);
        }, 8000);

        return () => clearTimeout(timer);
    }, [onDismiss]);

    const handleDismiss = useCallback(() => {
        setExiting(true);
        setTimeout(onDismiss, 400);
    }, [onDismiss]);

    const iconMap = {
        warning: '⚠️',
        critical: '🔴',
        info: 'ℹ️',
        success: '✅',
    };

    return (
        <div className={`toast-item ${visible ? 'visible' : ''} ${exiting ? 'exiting' : ''} toast-${alert.type || 'info'}`}>
            <div className="toast-icon">
                {iconMap[alert.type] || '📊'}
            </div>
            <div className="toast-content">
                <div className="toast-title">{alert.title || 'AMR Alert'}</div>
                <div className="toast-message">{alert.message}</div>
                {alert.action && (
                    <button className="toast-action-btn" onClick={alert.action.onClick}>
                        {alert.action.label}
                    </button>
                )}
            </div>
            <button className="toast-close" onClick={handleDismiss}>×</button>
        </div>
    );
}
